import { useEffect } from 'react';
import { css } from '@emotion/react';
import dayjs from 'dayjs';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { useCalendarGridStore } from '../../store/calendar-grid.store';

interface Props {
  hoveredEventId?: string;
  hoverTime: string;
}

export const EventTooltipContent = ({ hoveredEventId, hoverTime }: Props) => {
  const hoveredEvent = useCalendarGridStore((state) => (hoveredEventId ? state.eventsById[hoveredEventId] : undefined));
  const renderEventTooltipRef = useCalendarGridStore((state) => state.renderEventTooltipRef);
  const isDebugMode = useCalendarGridStore((state) => state.debug);

  useEffect(() => {
    if (isDebugMode) {
      console.debug('hoveredEvent (debug mode)::', hoveredEvent);
    }
  }, [isDebugMode, hoveredEvent]);

  if (!hoveredEvent) return <Text>{hoverTime}</Text>;

  if (renderEventTooltipRef?.current && typeof renderEventTooltipRef.current === 'function') {
    const content = renderEventTooltipRef.current(hoveredEvent);
    if (content) return content;
  }

  const title =
    hoveredEvent.eventType === 'exceptionV3' || hoveredEvent.eventType === 'exceptionV2'
      ? hoveredEvent.title
      : undefined;

  const startTime = dayjs(hoveredEvent.startTime, 'HH:mm');
  const durationText = `${startTime.format('h:mm A')} - ${startTime
    .add(hoveredEvent.duration ?? 0, 'minute')
    .format('h:mm A')}`;

  return (
    <>
      <Text weight='bold' size='small' css={textStyle}>
        {title}
      </Text>
      <Text size='small' color='light'>
        {durationText}
      </Text>
    </>
  );
};

const textStyle = css({
  display: 'block',
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  marginBottom: theme.spacing(0.25),
});
